function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
}

function showToast(message, type = 'info') {
  if (typeof window.showSiteToast === 'function') {
    window.showSiteToast(message, type);
    return;
  }

  alert(message);
}

function getVodCardMeta(videoId, page) {
  const card = document.querySelector(`.gv-media-card[data-video-id="${CSS.escape(videoId)}"]`);

  return {
    streamTitle: card?.dataset.videoTitle?.trim() || '',
    durationSeconds: Number(card?.dataset.videoDuration || 0) || 0,
    gameUuid: page?.dataset.game?.trim() || '',
  };
}

async function fetchGalleryInfo(infoUrl, { videoId, gameUuid, durationSeconds }) {
  const url = new URL(infoUrl, window.location.origin);
  url.searchParams.set('video_id', videoId);
  url.searchParams.set('game_uuid', gameUuid);
  url.searchParams.set('duration_seconds', String(durationSeconds > 0 ? durationSeconds : 0));

  const resp = await fetch(url, {
    headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    credentials: 'same-origin',
  });
  const json = await resp.json();

  if (!resp.ok || !json.success) {
    throw new Error(json.error || 'خطا در دریافت اطلاعات ویدیو');
  }

  return json.data || {};
}

async function importGalleryVod({ importUrl, videoId, gameUuid, streamTitle, onProgress }) {
  const token = csrfToken();

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', importUrl);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    if (token) {
      xhr.setRequestHeader('X-CSRF-TOKEN', token);
    }

    xhr.upload.addEventListener('progress', (event) => {
      if (!event.lengthComputable || typeof onProgress !== 'function') {
        return;
      }

      onProgress(Math.min(100, Math.round((event.loaded / event.total) * 100)));
    });

    xhr.addEventListener('load', () => {
      let json = {};
      try {
        json = JSON.parse(xhr.responseText || '{}');
      } catch {
        json = {};
      }

      if (xhr.status >= 200 && xhr.status < 300 && json.success) {
        resolve(json);
        return;
      }

      reject(new Error(json.error || json.message || 'افزودن ویدیو به گالری ناموفق بود.'));
    });

    xhr.addEventListener('error', () => {
      reject(new Error('خطا در ارتباط با سرور'));
    });

    xhr.send(JSON.stringify({
      video_id: videoId,
      game_uuid: gameUuid,
      stream_title: streamTitle || null,
    }));
  });
}

export function initStreamVodGallery({
  page,
  wrapId = 'gv-top-player-wrap',
  getActiveVideoId,
} = {}) {
  if (!page || page.dataset.streamVodSaver !== '1') {
    return () => {};
  }

  const infoUrl = page.dataset.streamGalleryInfo?.trim();
  const importUrl = page.dataset.streamGalleryImport?.trim();

  if (!infoUrl || !importUrl || typeof getActiveVideoId !== 'function') {
    return () => {};
  }

  const wrap = document.getElementById(wrapId);
  const videoShell = wrap?.querySelector('.product-live-streams__video-shell');

  if (!wrap || !videoShell || videoShell.querySelector('.product-live-streams__vod-gallery-btn')) {
    return () => {};
  }

  const galleryBtn = document.createElement('button');
  galleryBtn.type = 'button';
  galleryBtn.className = 'product-live-streams__ctrl-btn product-live-streams__vod-gallery-btn';
  galleryBtn.setAttribute('aria-label', 'افزودن ویدیو به گالری محصولات');
  galleryBtn.title = 'افزودن به گالری محصولات متصل';
  galleryBtn.textContent = '📥';
  galleryBtn.hidden = true;

  videoShell.appendChild(galleryBtn);

  const panel = document.createElement('div');
  panel.className = 'stream-recording-save-panel stream-gallery-panel';
  panel.hidden = true;
  panel.innerHTML =
    '<div class="stream-recording-save-panel__dialog" role="dialog" aria-modal="true" aria-labelledby="stream-vod-gallery-title">'
    + '<p class="stream-recording-save-panel__title" id="stream-vod-gallery-title">افزودن به گالری</p>'
    + '<p class="stream-recording-save-panel__meta" data-gallery-meta></p>'
    + '<ul class="stream-gallery-panel__facts" data-gallery-facts hidden></ul>'
    + '<div class="stream-recording-save-panel__progress-wrap" data-gallery-progress hidden>'
    + '<div class="stream-recording-save-panel__progress-track">'
    + '<div class="stream-recording-save-panel__progress-bar" style="width:0%"></div>'
    + '</div>'
    + '<span class="stream-recording-save-panel__progress-label">در حال دانلود…</span>'
    + '</div>'
    + '<div class="stream-gallery-panel__actions" data-gallery-actions>'
    + '<button type="button" class="stream-gallery-panel__btn stream-gallery-panel__btn--ghost" data-gallery-cancel>لغو</button>'
    + '<button type="button" class="stream-gallery-panel__btn stream-gallery-panel__btn--primary" data-gallery-confirm disabled>تأیید و دانلود</button>'
    + '</div>'
    + '</div>';
  wrap.appendChild(panel);

  const metaEl = panel.querySelector('[data-gallery-meta]');
  const factsEl = panel.querySelector('[data-gallery-facts]');
  const progressWrap = panel.querySelector('[data-gallery-progress]');
  const progressBar = panel.querySelector('.stream-recording-save-panel__progress-bar');
  const progressLabel = panel.querySelector('.stream-recording-save-panel__progress-label');
  const actionsEl = panel.querySelector('[data-gallery-actions]');
  const cancelBtn = panel.querySelector('[data-gallery-cancel]');
  const confirmBtn = panel.querySelector('[data-gallery-confirm]');

  let busy = false;
  let pendingInfo = null;

  const setPanelOpen = (open) => {
    panel.hidden = !open;
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
  };

  const setProgress = (percent, label) => {
    const safe = Math.max(0, Math.min(100, Number(percent) || 0));
    progressBar.style.width = `${safe}%`;
    progressLabel.textContent = label || `در حال دانلود… ${safe}٪`;
  };

  const renderFacts = (info) => {
    const items = [
      ['کیفیت', info.quality_label || '—'],
      ['حجم تقریبی', info.estimated_label || 'نامشخص'],
      ['محصولات مقصد', `${info.product_count || 0} محصول`],
    ];

    factsEl.innerHTML = items
      .map(([k, v]) => `<li><span>${k}</span><strong>${v}</strong></li>`)
      .join('');
    factsEl.hidden = false;
  };

  const syncButton = () => {
    const videoId = getActiveVideoId();
    const isOpen = wrap.classList.contains('is-open');
    galleryBtn.hidden = !isOpen || !videoId;
    galleryBtn.disabled = busy;
  };

  const closePanel = () => {
    if (busy) return;
    setPanelOpen(false);
    pendingInfo = null;
  };

  const openDialog = async (videoId) => {
    const meta = getVodCardMeta(videoId, page);

    if (!meta.gameUuid) {
      showToast('بازی این صفحه شناسایی نشد.', 'warning');
      return;
    }

    busy = false;
    pendingInfo = null;
    setPanelOpen(true);
    metaEl.textContent = meta.streamTitle || `ویدیو ${videoId}`;
    factsEl.hidden = true;
    factsEl.innerHTML = '';
    progressWrap.hidden = true;
    actionsEl.hidden = false;
    confirmBtn.disabled = true;
    confirmBtn.textContent = 'در حال بررسی…';
    syncButton();

    try {
      const info = await fetchGalleryInfo(infoUrl, {
        videoId,
        gameUuid: meta.gameUuid,
        durationSeconds: meta.durationSeconds,
      });

      pendingInfo = { videoId, meta, info };
      renderFacts(info);
      confirmBtn.textContent = 'تأیید و دانلود';

      if (!info.has_products) {
        confirmBtn.disabled = true;
        metaEl.textContent = 'هیچ محصولی به این استریم متصل نیست.';
      } else {
        confirmBtn.disabled = false;
      }
    } catch (error) {
      confirmBtn.textContent = 'تأیید و دانلود';
      confirmBtn.disabled = true;
      showToast(error?.message || 'خطا در دریافت اطلاعات ویدیو', 'error');
      setPanelOpen(false);
    }
  };

  const runImport = async () => {
    if (!pendingInfo || busy) return;

    const { videoId, meta } = pendingInfo;
    busy = true;
    syncButton();
    actionsEl.hidden = true;
    progressWrap.hidden = false;
    setProgress(5, 'در حال دانلود روی سرور… ممکن است چند دقیقه طول بکشد');

    try {
      const result = await importGalleryVod({
        importUrl,
        videoId,
        gameUuid: meta.gameUuid,
        streamTitle: meta.streamTitle,
        onProgress: (percent) => {
          setProgress(Math.max(5, percent), percent >= 100 ? 'در حال نهایی‌سازی…' : `در حال دانلود… ${percent}٪`);
        },
      });

      busy = false;
      setPanelOpen(false);
      pendingInfo = null;
      syncButton();
      showToast(result.message || 'ویدیو به گالری محصولات اضافه شد.', 'success');
    } catch (error) {
      busy = false;
      progressWrap.hidden = true;
      actionsEl.hidden = false;
      syncButton();
      showToast(error?.message || 'افزودن ویدیو به گالری ناموفق بود.', 'error');
    }
  };

  galleryBtn.addEventListener('click', () => {
    if (busy) return;

    const videoId = getActiveVideoId();
    if (!videoId) {
      showToast('ابتدا یک ویدیو را انتخاب کنید.', 'warning');
      return;
    }

    openDialog(videoId);
  });

  cancelBtn.addEventListener('click', closePanel);
  confirmBtn.addEventListener('click', runImport);

  const pollTimer = window.setInterval(syncButton, 400);
  wrap.addEventListener('transitionend', syncButton);

  syncButton();

  return () => {
    window.clearInterval(pollTimer);
    galleryBtn.remove();
    panel.remove();
    busy = false;
    pendingInfo = null;
  };
}
